var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebijenkorfAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8977 20L23.0043 27.9993L23 44.005L35.8977 52L48.7279 44.0453V27.9648L35.8977 20ZM34.7625 48.5442L25.22 42.6227L25.2243 29.3888L34.7625 23.4673V25.0263C32.7121 25.3295 30.0279 27.7493 30.0279 31.0484L30.0222 36.4153L26.4529 36.4167V42.3425H34.7625V48.5442ZM36.9725 48.5658L36.9783 39.9443L28.6657 39.9529L28.6629 38.8063L32.2422 38.8077V31.1361C32.2379 29.1646 33.7208 27.2535 36.0989 27.2535H36.974L36.9783 23.4342L46.5107 29.3485L46.5136 42.6558L36.9725 48.5658Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebijenkorfAppIcon);
export default __webpack_public_path__ + "static/media/debijenkorf-app-icon.3a77f43fa858eb50026d6fba2a5368fc.svg";
export { ForwardRef as ReactComponent };